"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Autocomplete = _interopRequireDefault(require("./Autocomplete"));

var _simpleOptions = require("../../utils/simpleOptions");

var _excluded = ["form", "field", "user"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CarouselTypeAutocomplete = function CarouselTypeAutocomplete(_ref) {
  var form = _ref.form,
      field = _ref.field,
      user = _ref.user,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    fetchOptions: fetchOptions,
    getOptionLabel: getCarouselTypeOptionLabel,
    getOptionSelected: getCarouselTypeOptionSelected,
    renderOption: renderCarouselTypeOption,
    field: field,
    form: form
  }, props));
};

var _default = CarouselTypeAutocomplete;
exports["default"] = _default;

var fetchOptions = function fetchOptions(_ref2) {
  var setOptions = _ref2.setOptions,
      setLoading = _ref2.setLoading,
      active = _ref2.active,
      query = _ref2.query;

  if (active) {
    setOptions(_simpleOptions.carouselTypeOptions);
    setLoading(false);
  }
};

var getCarouselTypeOptionSelected = function getCarouselTypeOptionSelected(option, value) {
  return option.value === value.value;
};

var getCarouselTypeOptionLabel = function getCarouselTypeOptionLabel(option) {
  return option === "" ? "" : option.label;
};

var renderCarouselTypeOption = function renderCarouselTypeOption(option) {
  return option.label;
};